import be, { createContext as nl, useContext as Sl } from "react";
const Fl = [
  "AccessibilityBoldFilled",
  "AccessibilityBoldStroke",
  "AccessibilityMediumFilled",
  "AccessibilityMediumStroke",
  "AccessibilityRegularFilled",
  "AccessibilityRegularStroke",
  "AddGroupBoldFilled",
  "AddGroupBoldStroke",
  "AddGroupMediumFilled",
  "AddGroupMediumStroke",
  "AddGroupRegularFilled",
  "AddGroupRegularStroke",
  "AddImageBoldFilled",
  "AddImageBoldStroke",
  "AddImageMediumFilled",
  "AddImageMediumStroke",
  "AddImageRegularFilled",
  "AddImageRegularStroke",
  "AddPlaceholderBoldStroke",
  "AddShapeBoldFilled",
  "AddShapeBoldStroke",
  "AddShapeMediumFilled",
  "AddShapeMediumStroke",
  "AddShapeRegularFilled",
  "AddShapeRegularStroke",
  "AddTextBoldFilled",
  "AddTextBoldStroke",
  "AddTextMediumFilled",
  "AddTextMediumStroke",
  "AddTextRegularFilled",
  "AddTextRegularStroke",
  "AddUserBoldFilled",
  "AddUserBoldStroke",
  "AddUserMediumFilled",
  "AddUserMediumStroke",
  "AddUserRegularFilled",
  "AddUserRegularStroke",
  "AlertInCircleBoldFilled",
  "AlertInCircleBoldStroke",
  "AlertInCircleMediumFilled",
  "AlertInCircleMediumStroke",
  "AlertInCircleRegularFilled",
  "AlertInCircleRegularStroke",
  "AlignBottomBoldFilled",
  "AlignHorizontalCentersBoldFilled",
  "AlignLeftBoldFilled",
  "AlignRightBoldFilled",
  "AlignTopBoldFilled",
  "AlignVerticalCentersBoldFilled",
  "AngleBoldStroke",
  "AngleMediumStroke",
  "AngleRegularStroke",
  "ApplicationsBoldFilled",
  "ApplicationsBoldStroke",
  "ApplicationsMediumFilled",
  "ApplicationsMediumStroke",
  "ApplicationsRegularFilled",
  "ApplicationsRegularStroke",
  "ArchiveBoldFilled",
  "ArchiveBoldStroke",
  "ArchiveMediumFilled",
  "ArchiveMediumStroke",
  "ArchiveRegularFilled",
  "ArchiveRegularStroke",
  "ArrowDownBoldStroke",
  "ArrowDownMediumStroke",
  "ArrowDownRegularStroke",
  "ArrowInCircleDownBoldFilled",
  "ArrowInCircleDownBoldStroke",
  "ArrowInCircleDownMediumFilled",
  "ArrowInCircleDownMediumStroke",
  "ArrowInCircleDownRegularFilled",
  "ArrowInCircleDownRegularStroke",
  "ArrowInCircleLeftBoldFilled",
  "ArrowInCircleLeftBoldStroke",
  "ArrowInCircleLeftMediumFilled",
  "ArrowInCircleLeftMediumStroke",
  "ArrowInCircleLeftRegularFilled",
  "ArrowInCircleLeftRegularStroke",
  "ArrowInCircleRightBoldFilled",
  "ArrowInCircleRightBoldStroke",
  "ArrowInCircleRightMediumFilled",
  "ArrowInCircleRightMediumStroke",
  "ArrowInCircleRightRegularFilled",
  "ArrowInCircleRightRegularStroke",
  "ArrowInCircleUpBoldFilled",
  "ArrowInCircleUpBoldStroke",
  "ArrowInCircleUpMediumFilled",
  "ArrowInCircleUpMediumStroke",
  "ArrowInCircleUpRegularFilled",
  "ArrowInCircleUpRegularStroke",
  "ArrowLeftBoldStroke",
  "ArrowLeftMediumStroke",
  "ArrowLeftRegularStroke",
  "ArrowRightBoldStroke",
  "ArrowRightMediumStroke",
  "ArrowRightRegularStroke",
  "ArrowThinDownBoldStroke",
  "ArrowThinDownMediumStroke",
  "ArrowThinDownRegularStroke",
  "ArrowThinLeftBoldStroke",
  "ArrowThinLeftMediumStroke",
  "ArrowThinLeftRegularStroke",
  "ArrowThinRightBoldStroke",
  "ArrowThinRightMediumStroke",
  "ArrowThinRightRegularStroke",
  "ArrowThinUpBoldStroke",
  "ArrowThinUpMediumStroke",
  "ArrowThinUpRegularStroke",
  "ArrowUpBoldStroke",
  "ArrowUpMediumStroke",
  "ArrowUpRegularStroke",
  "ArrowsUpAndDownBoldStroke",
  "ArrowsUpAndDownMediumStroke",
  "ArrowsUpAndDownRegularStroke",
  "AttachDiagonalBoldStroke",
  "AttachDiagonalMediumStroke",
  "AttachDiagonalRegularStroke",
  "AttachVerticalBoldStroke",
  "AttachVerticalMediumStroke",
  "AttachVerticalRegularStroke",
  "AvAvatarImage1BoldStroke",
  "AvAvatarImage2BoldStroke",
  "AvAvatarImage3BoldStroke",
  "AvAvatarImage4BoldStroke",
  "AvAvatarImage5BoldStroke",
  "AvAvatarOnly1BoldStroke",
  "AvImageOnly1BoldStroke",
  "AvImageOnly2BoldStroke",
  "AvImageOnly3BoldStroke",
  "BankCardBoldFilled",
  "BankCardBoldStroke",
  "BankCardMediumFilled",
  "BankCardMediumStroke",
  "BankCardRegularFilled",
  "BankCardRegularStroke",
  "BlockBoldFilled",
  "BlockBoldStroke",
  "BlockMediumFilled",
  "BlockMediumStroke",
  "BlockRegularFilled",
  "BlockRegularStroke",
  "BoldTextRegularFilled",
  "BookBoldFilled",
  "BookBoldStroke",
  "BookMediumFilled",
  "BookMediumStroke",
  "BookRegularFilled",
  "BookRegularStroke",
  "BookmarkBoldFilled",
  "BookmarkBoldStroke",
  "BookmarkMediumFilled",
  "BookmarkMediumStroke",
  "BookmarkRegularFilled",
  "BookmarkRegularStroke",
  "BottomSidePanelBoldStroke",
  "BottomSidePanelMediumStroke",
  "BottomSidePanelRegularStroke",
  "BoxAddBoldFilled",
  "BoxAddBoldStroke",
  "BoxAddMediumFilled",
  "BoxAddMediumStroke",
  "BoxAddRegularFilled",
  "BoxAddRegularStroke",
  "BoxCloseBoldFilled",
  "BoxCloseBoldStroke",
  "BoxCloseMediumFilled",
  "BoxCloseMediumStroke",
  "BoxCloseRegularFilled",
  "BoxCloseRegularStroke",
  "BoxDeleteBoldFilled",
  "BoxDeleteBoldStroke",
  "BoxDeleteMediumFilled",
  "BoxDeleteMediumStroke",
  "BoxDeleteRegularFilled",
  "BoxDeleteRegularStroke",
  "BrowserBoldFilled",
  "BrowserBoldStroke",
  "BrowserMediumFilled",
  "BrowserMediumStroke",
  "BrowserRegularFilled",
  "BrowserRegularStroke",
  "CalculatorBoldFilled",
  "CalculatorBoldStroke",
  "CalculatorMediumFilled",
  "CalculatorMediumStroke",
  "CalculatorRegularFilled",
  "CalculatorRegularStroke",
  "CalendarBoldFilled",
  "CalendarBoldStroke",
  "CalendarMediumFilled",
  "CalendarMediumStroke",
  "CalendarRegularFilled",
  "CalendarRegularStroke",
  "CameraBoldFilled",
  "CameraBoldStroke",
  "CameraMediumFilled",
  "CameraMediumStroke",
  "CameraOffBoldStroke",
  "CameraOnBoldFilled",
  "CameraOnBoldStroke",
  "CameraRegularFilled",
  "CameraRegularStroke",
  "CameraVideoBoldFilled",
  "CameraVideoBoldStroke",
  "CameraVideoMediumFilled",
  "CameraVideoMediumStroke",
  "CameraVideoOffBoldFilled",
  "CameraVideoOffBoldStroke",
  "CameraVideoOffMediumFilled",
  "CameraVideoOffMediumStroke",
  "CameraVideoOffRegularFilled",
  "CameraVideoOffRegularStroke",
  "CameraVideoRegularFilled",
  "CameraVideoRegularStroke",
  "CancelCallBoldFilled",
  "CancelCallBoldStroke",
  "CancelCallMediumFilled",
  "CancelCallMediumStroke",
  "CancelCallRegularFilled",
  "CancelCallRegularStroke",
  "CatalogBoldFilled",
  "CatalogBoldStroke",
  "CatalogMediumFilled",
  "CatalogMediumStroke",
  "CatalogRegularFilled",
  "CatalogRegularStroke",
  "ChartBarBoldStroke",
  "ChartBarMediumStroke",
  "ChartBarRegularStroke",
  "CheckAllBoldStroke",
  "CheckAllMediumStroke",
  "CheckAllRegularStroke",
  "CheckBoldStroke",
  "CheckInCircleBoldFilled",
  "CheckInCircleBoldStroke",
  "CheckInCircleMediumFilled",
  "CheckInCircleMediumStroke",
  "CheckInCircleRegularFilled",
  "CheckInCircleRegularStroke",
  "CheckMediumStroke",
  "CheckRegularStroke",
  "ChevronDownBoldStroke",
  "ChevronDownDoubleBoldStroke",
  "ChevronDownDoubleMediumStroke",
  "ChevronDownDoubleRegularStroke",
  "ChevronDownMediumStroke",
  "ChevronDownRegularStroke",
  "ChevronLeftBoldStroke",
  "ChevronLeftDoubleBoldStroke",
  "ChevronLeftDoubleMediumStroke",
  "ChevronLeftDoubleRegularStroke",
  "ChevronLeftMediumStroke",
  "ChevronLeftRegularStroke",
  "ChevronRightBoldStroke",
  "ChevronRightDoubleBoldStroke",
  "ChevronRightDoubleMediumStroke",
  "ChevronRightDoubleRegularStroke",
  "ChevronRightMediumStroke",
  "ChevronRightRegularStroke",
  "ChevronSmallDownBoldStroke",
  "ChevronSmallDownMediumStroke",
  "ChevronSmallDownRegularStroke",
  "ChevronSmallLeftBoldStroke",
  "ChevronSmallLeftMediumStroke",
  "ChevronSmallLeftRegularStroke",
  "ChevronSmallRightBoldStroke",
  "ChevronSmallRightMediumStroke",
  "ChevronSmallRightRegularStroke",
  "ChevronSmallUpBoldStroke",
  "ChevronSmallUpMediumStroke",
  "ChevronSmallUpRegularStroke",
  "ChevronUpBoldStroke",
  "ChevronUpDoubleBoldStroke",
  "ChevronUpDoubleMediumStroke",
  "ChevronUpDoubleRegularStroke",
  "ChevronUpMediumStroke",
  "ChevronUpRegularStroke",
  "CircleBoldFilled",
  "CircleBoldStroke",
  "CircleMediumFilled",
  "CircleMediumStroke",
  "CircleRegularFilled",
  "CircleRegularStroke",
  "CityBoldFilled",
  "CityBoldStroke",
  "CityMediumFilled",
  "CityMediumStroke",
  "CityRegularFilled",
  "CityRegularStroke",
  "ClipboardAddBoldFilled",
  "ClipboardAddBoldStroke",
  "ClipboardAddMediumFilled",
  "ClipboardAddMediumStroke",
  "ClipboardAddRegularFilled",
  "ClipboardAddRegularStroke",
  "ClipboardBoldFilled",
  "ClipboardBoldStroke",
  "ClipboardMediumFilled",
  "ClipboardMediumStroke",
  "ClipboardRegularFilled",
  "ClipboardRegularStroke",
  "CloseBoldStroke",
  "CloseInCircleBoldFilled",
  "CloseInCircleBoldStroke",
  "CloseInCircleMediumFilled",
  "CloseInCircleMediumStroke",
  "CloseInCircleRegularFilled",
  "CloseInCircleRegularStroke",
  "CloseMediumStroke",
  "CloseRegularStroke",
  "CloudOffBoldFilled",
  "CloudOffBoldStroke",
  "CloudOffMediumFilled",
  "CloudOffMediumStroke",
  "CloudOffRegularFilled",
  "CloudOffRegularStroke",
  "CloudQueueBoldFilled",
  "CloudQueueBoldStroke",
  "CloudQueueMediumFilled",
  "CloudQueueMediumStroke",
  "CloudQueueRegularFilled",
  "CloudQueueRegularStroke",
  "CloudUploadBoldFilled",
  "CloudUploadBoldStroke",
  "CloudUploadMediumFilled",
  "CloudUploadMediumStroke",
  "CloudUploadRegularFilled",
  "CloudUploadRegularStroke",
  "CodeBoldStroke",
  "CodeMediumStroke",
  "CodeRegularStroke",
  "CollapseBoldStroke",
  "CollapseMediumStroke",
  "CollapseRegularStroke",
  "CollapseV2BoldStroke",
  "CollapseV2MediumStroke",
  "CollapseV2RegularStroke",
  "CollegeBoldFilled",
  "CollegeBoldStroke",
  "CollegeMediumFilled",
  "CollegeMediumStroke",
  "CollegeRegularFilled",
  "CollegeRegularStroke",
  "ColumnSelectorBoldFilled",
  "ColumnSelectorBoldStroke",
  "ColumnSelectorMediumFilled",
  "ColumnSelectorMediumStroke",
  "ColumnSelectorRegularFilled",
  "ColumnSelectorRegularStroke",
  "CompositeBoldFilled",
  "CompositeBoldStroke",
  "CompositeMediumFilled",
  "CompositeMediumStroke",
  "CompositeRegularFilled",
  "CompositeRegularStroke",
  "ConnectorBoldFilled",
  "ConnectorBoldStroke",
  "ConnectorMediumFilled",
  "ConnectorMediumStroke",
  "ConnectorRegularFilled",
  "ConnectorRegularStroke",
  "ContentBoldFilled",
  "ContentBoldStroke",
  "ContentMediumFilled",
  "ContentMediumStroke",
  "ContentRegularFilled",
  "ContentRegularStroke",
  "CoordinatesBoldStroke",
  "CoordinatesMediumStroke",
  "CoordinatesRegularStroke",
  "CopyBoldFilled",
  "CopyBoldStroke",
  "CopyMediumFilled",
  "CopyMediumStroke",
  "CopyRegularFilled",
  "CopyRegularStroke",
  "CorrectionHistoryBoldStroke",
  "CorrectionHistoryMediumStroke",
  "CorrectionHistoryRegularStroke",
  "CourseBoldFilled",
  "CourseBoldStroke",
  "CourseMediumFilled",
  "CourseMediumStroke",
  "CourseRegularFilled",
  "CourseRegularStroke",
  "CropBoldStroke",
  "CropMediumStroke",
  "CropRegularStroke",
  "CsvBoldFilled",
  "CsvBoldStroke",
  "CsvMediumFilled",
  "CsvMediumStroke",
  "CsvRegularFilled",
  "CsvRegularStroke",
  "DashboardBoldFilled",
  "DashboardBoldStroke",
  "DashboardMediumFilled",
  "DashboardMediumStroke",
  "DashboardRegularFilled",
  "DashboardRegularStroke",
  "DateRangeBoldFilled",
  "DateRangeBoldStroke",
  "DateRangeMediumFilled",
  "DateRangeMediumStroke",
  "DateRangeRegularFilled",
  "DateRangeRegularStroke",
  "DeleteBoldFilled",
  "DeleteBoldStroke",
  "DeleteMediumFilled",
  "DeleteMediumStroke",
  "DeleteRegularFilled",
  "DeleteRegularStroke",
  "DesktopBoldFilled",
  "DesktopBoldStroke",
  "DesktopMediumFilled",
  "DesktopMediumStroke",
  "DesktopRegularFilled",
  "DesktopRegularStroke",
  "DesktopWindowsTurnOffBoldFilled",
  "DesktopWindowsTurnOffBoldStroke",
  "DesktopWindowsTurnOffMediumFilled",
  "DesktopWindowsTurnOffMediumStroke",
  "DesktopWindowsTurnOffRegularFilled",
  "DesktopWindowsTurnOffRegularStroke",
  "DistributeHorizontalSpacingsBoldFilled",
  "DistributeVerticalSpacingsBoldFilled",
  "DocumentTableBoldFilled",
  "DocumentTableBoldStroke",
  "DocumentTableMediumFilled",
  "DocumentTableMediumStroke",
  "DocumentTableRegularFilled",
  "DocumentTableRegularStroke",
  "DownloadBoldStroke",
  "DownloadMediumStroke",
  "DownloadRegularStroke",
  "DownwardsArrowBoldStroke",
  "DownwardsArrowMediumStroke",
  "DownwardsArrowRegularStroke",
  "DragBoldStroke",
  "DragMediumStroke",
  "DragRegularStroke",
  "DropBoldFilled",
  "DropBoldStroke",
  "DropMediumFilled",
  "DropMediumStroke",
  "DropRegularFilled",
  "DropRegularStroke",
  "DuplicateBoldFilled",
  "DuplicateBoldStroke",
  "DuplicateMediumFilled",
  "DuplicateMediumStroke",
  "DuplicateRegularFilled",
  "DuplicateRegularStroke",
  "EditBoldFilled",
  "EditBoldStroke",
  "EditMediumFilled",
  "EditMediumStroke",
  "EditRegularFilled",
  "EditRegularStroke",
  "EnergyElectricityBoldFilled",
  "EnergyElectricityBoldStroke",
  "EnergyElectricityMediumFilled",
  "EnergyElectricityMediumStroke",
  "EnergyElectricityRegularFilled",
  "EnergyElectricityRegularStroke",
  "EnvironmentBoldFilled",
  "EnvironmentBoldStroke",
  "EnvironmentMediumFilled",
  "EnvironmentMediumStroke",
  "EnvironmentRegularFilled",
  "EnvironmentRegularStroke",
  "EqualBoldStroke",
  "EqualMediumStroke",
  "EqualRegularStroke",
  "ExitBoldFilled",
  "ExitBoldStroke",
  "ExitLtrBoldFilled",
  "ExitLtrBoldStroke",
  "ExitLtrMediumFilled",
  "ExitLtrMediumStroke",
  "ExitLtrRegularFilled",
  "ExitLtrRegularStroke",
  "ExitMediumFilled",
  "ExitMediumStroke",
  "ExitRegularFilled",
  "ExitRegularStroke",
  "ExpandBoldStroke",
  "ExpandMediumStroke",
  "ExpandRegularStroke",
  "ExpandV2BoldStroke",
  "ExpandV2MediumStroke",
  "ExpandV2RegularStroke",
  "EyeClosedBoldStroke",
  "EyeClosedMediumStroke",
  "EyeClosedRegularStroke",
  "EyeOpenedBoldFilled",
  "EyeOpenedBoldStroke",
  "EyeOpenedMediumFilled",
  "EyeOpenedMediumStroke",
  "EyeOpenedRegularFilled",
  "EyeOpenedRegularStroke",
  "FaceFrowningBoldFilled",
  "FaceFrowningBoldStroke",
  "FaceFrowningMediumFilled",
  "FaceFrowningMediumStroke",
  "FaceFrowningRegularFilled",
  "FaceFrowningRegularStroke",
  "FaceSmilingBoldFilled",
  "FaceSmilingBoldStroke",
  "FaceSmilingMediumFilled",
  "FaceSmilingMediumStroke",
  "FaceSmilingRegularFilled",
  "FaceSmilingRegularStroke",
  "FadeBoldFilled",
  "FileAddBoldFilled",
  "FileAddBoldStroke",
  "FileAddMediumFilled",
  "FileAddMediumStroke",
  "FileAddRegularFilled",
  "FileAddRegularStroke",
  "FileBoldFilled",
  "FileBoldStroke",
  "FileDiagramBoldFilled",
  "FileDiagramBoldStroke",
  "FileDiagramMediumFilled",
  "FileDiagramMediumStroke",
  "FileDiagramRegularFilled",
  "FileDiagramRegularStroke",
  "FileMediumFilled",
  "FileMediumStroke",
  "FileRegularFilled",
  "FileRegularStroke",
  "FilterAddBoldFilled",
  "FilterAddBoldStroke",
  "FilterAddMediumFilled",
  "FilterAddMediumStroke",
  "FilterAddRegularFilled",
  "FilterAddRegularStroke",
  "FilterBoldFilled",
  "FilterBoldStroke",
  "FilterMediumFilled",
  "FilterMediumStroke",
  "FilterRegularFilled",
  "FilterRegularStroke",
  "FilterRemoveBoldFilled",
  "FilterRemoveBoldStroke",
  "FilterRemoveMediumFilled",
  "FilterRemoveMediumStroke",
  "FilterRemoveRegularFilled",
  "FilterRemoveRegularStroke",
  "FilterResetBoldFilled",
  "FilterResetBoldStroke",
  "FilterResetMediumFilled",
  "FilterResetMediumStroke",
  "FilterResetRegularFilled",
  "FilterResetRegularStroke",
  "FlagBoldFilled",
  "FlagBoldStroke",
  "FlagMediumFilled",
  "FlagMediumStroke",
  "FlagRegularFilled",
  "FlagRegularStroke",
  "FocusBoldFilled",
  "FocusBoldStroke",
  "FocusMediumFilled",
  "FocusMediumStroke",
  "FocusRegularFilled",
  "FocusRegularStroke",
  "FolderBoldFilled",
  "FolderBoldStroke",
  "FolderMediumFilled",
  "FolderMediumStroke",
  "FolderOpenedBoldFilled",
  "FolderOpenedBoldStroke",
  "FolderOpenedMediumFilled",
  "FolderOpenedMediumStroke",
  "FolderOpenedRegularFilled",
  "FolderOpenedRegularStroke",
  "FolderRegularFilled",
  "FolderRegularStroke",
  "FolderToCreateBoldFilled",
  "FolderToCreateBoldStroke",
  "FolderToCreateMediumFilled",
  "FolderToCreateMediumStroke",
  "FolderToCreateRegularFilled",
  "FolderToCreateRegularStroke",
  "ForceSubmitBoldFilled",
  "ForceSubmitBoldStroke",
  "ForceSubmitMediumFilled",
  "ForceSubmitMediumStroke",
  "ForceSubmitRegularFilled",
  "ForceSubmitRegularStroke",
  "FullTimelineBoldFilled",
  "FullTimelineBoldStroke",
  "FullTimelineMediumFilled",
  "FullTimelineMediumStroke",
  "FullTimelineRegularFilled",
  "FullTimelineRegularStroke",
  "FullViewBoldFilled",
  "FullViewBoldStroke",
  "FullViewMediumFilled",
  "FullViewMediumStroke",
  "FullViewRegularFilled",
  "FullViewRegularStroke",
  "FullscreenBoldStroke",
  "FullscreenExitBoldStroke",
  "FullscreenExitMediumStroke",
  "FullscreenExitRegularStroke",
  "FullscreenMediumStroke",
  "FullscreenRegularStroke",
  "GradeBoldStroke",
  "GradeMediumStroke",
  "GradeRegularStroke",
  "GradebookBoldFilled",
  "GradebookBoldStroke",
  "GradebookMediumFilled",
  "GradebookMediumStroke",
  "GradebookRegularFilled",
  "GradebookRegularStroke",
  "GradingScaleBoldStroke",
  "GradingScaleMediumStroke",
  "GradingScaleRegularStroke",
  "GridBoldFilled",
  "GridBoldStroke",
  "GridBottomBoldFilled",
  "GridMediumFilled",
  "GridMediumStroke",
  "GridRegularFilled",
  "GridRegularStroke",
  "GridRightBoldFilled",
  "GridTopBoldFilled",
  "GroupBoldFilled",
  "GroupBoldStroke",
  "GroupMediumFilled",
  "GroupMediumStroke",
  "GroupRegularFilled",
  "GroupRegularStroke",
  "GroupWithLeaderBoldFilled",
  "GroupWithLeaderBoldStroke",
  "GroupWithLeaderMediumFilled",
  "GroupWithLeaderMediumStroke",
  "GroupWithLeaderRegularFilled",
  "GroupWithLeaderRegularStroke",
  "HandBoldFilled",
  "HandBoldStroke",
  "HandMediumFilled",
  "HandMediumStroke",
  "HandRegularFilled",
  "HandRegularStroke",
  "HeadphoneBoldFilled",
  "HeadphoneBoldStroke",
  "HeadphoneMediumFilled",
  "HeadphoneMediumStroke",
  "HeadphoneRegularFilled",
  "HeadphoneRegularStroke",
  "HelpInCircleBoldFilled",
  "HelpInCircleBoldStroke",
  "HelpInCircleMediumFilled",
  "HelpInCircleMediumStroke",
  "HelpInCircleRegularFilled",
  "HelpInCircleRegularStroke",
  "HistoryBoldStroke",
  "HistoryMediumStroke",
  "HistoryRegularStroke",
  "HomeBoldFilled",
  "HomeBoldStroke",
  "HomeMediumFilled",
  "HomeMediumStroke",
  "HomeRegularFilled",
  "HomeRegularStroke",
  "HorizonPageBoldFilled",
  "HorizonPageBoldStroke",
  "HorizonPageMediumFilled",
  "HorizonPageMediumStroke",
  "HorizonPageRegularFilled",
  "HorizonPageRegularStroke",
  "HourglassBoldFilled",
  "HourglassBoldStroke",
  "HourglassMediumFilled",
  "HourglassMediumStroke",
  "HourglassRegularFilled",
  "HourglassRegularStroke",
  "HumanInRoundedSquareBoldFilled",
  "HumanInRoundedSquareBoldStroke",
  "HumanInRoundedSquareMediumFilled",
  "HumanInRoundedSquareMediumStroke",
  "HumanInRoundedSquareRegularFilled",
  "HumanInRoundedSquareRegularStroke",
  "ImageBoldFilled",
  "ImageBoldStroke",
  "ImageMediumFilled",
  "ImageMediumStroke",
  "ImageRegularFilled",
  "ImageRegularStroke",
  "InboxBoldFilled",
  "InboxBoldStroke",
  "InboxMediumFilled",
  "InboxMediumStroke",
  "InboxRegularFilled",
  "InboxRegularStroke",
  "InformationInCircleBoldFilled",
  "InformationInCircleBoldStroke",
  "InformationInCircleMediumFilled",
  "InformationInCircleMediumStroke",
  "InformationInCircleRegularFilled",
  "InformationInCircleRegularStroke",
  "InstructorBoldFilled",
  "InstructorBoldStroke",
  "InstructorMediumFilled",
  "InstructorMediumStroke",
  "InstructorRegularFilled",
  "InstructorRegularStroke",
  "InvertColorsBoldFilled",
  "InvertColorsBoldStroke",
  "InvertColorsMediumFilled",
  "InvertColorsMediumStroke",
  "InvertColorsRegularFilled",
  "InvertColorsRegularStroke",
  "ItalicTextRegularFilled",
  "LabBoldFilled",
  "LabBoldStroke",
  "LabMediumFilled",
  "LabMediumStroke",
  "LabRegularFilled",
  "LabRegularStroke",
  "LaptopBoldFilled",
  "LaptopBoldStroke",
  "LaptopMediumFilled",
  "LaptopMediumStroke",
  "LaptopRegularFilled",
  "LaptopRegularStroke",
  "LeftSidePanelBoldStroke",
  "LeftSidePanelMediumStroke",
  "LeftSidePanelRegularStroke",
  "LightBulbBoldFilled",
  "LightBulbBoldStroke",
  "LightBulbMediumFilled",
  "LightBulbMediumStroke",
  "LightBulbRegularFilled",
  "LightBulbRegularStroke",
  "LinkBoldStroke",
  "LinkMediumStroke",
  "LinkRegularStroke",
  "ListBoldStroke",
  "ListBulletedBoldStroke",
  "ListBulletedMediumStroke",
  "ListBulletedRegularStroke",
  "ListMediumStroke",
  "ListRegularStroke",
  "ListWithCheckBoldStroke",
  "ListWithCheckMediumStroke",
  "ListWithCheckRegularStroke",
  "ListWithPlayBoldStroke",
  "ListWithPlayMediumStroke",
  "ListWithPlayRegularStroke",
  "ListWithPlusBoldStroke",
  "ListWithPlusMediumStroke",
  "ListWithPlusRegularStroke",
  "LockBoldFilled",
  "LockBoldStroke",
  "LockMediumFilled",
  "LockMediumStroke",
  "LockRegularFilled",
  "LockRegularStroke",
  "LoopBoldStroke",
  "LoopMediumStroke",
  "LoopRegularStroke",
  "LtiScormBoldFilled",
  "LtiScormBoldStroke",
  "LtiScormMediumFilled",
  "LtiScormMediumStroke",
  "LtiScormRegularFilled",
  "LtiScormRegularStroke",
  "MailBoldFilled",
  "MailBoldStroke",
  "MailMediumFilled",
  "MailMediumStroke",
  "MailRegularFilled",
  "MailRegularStroke",
  "ManBoldFilled",
  "ManBoldStroke",
  "ManMediumFilled",
  "ManMediumStroke",
  "ManRegularFilled",
  "ManRegularStroke",
  "MathTextRegularFilled",
  "MenuBoldStroke",
  "MenuMediumStroke",
  "MenuRegularStroke",
  "MessageBoldFilled",
  "MessageBoldStroke",
  "MessageMediumFilled",
  "MessageMediumStroke",
  "MessageRegularFilled",
  "MessageRegularStroke",
  "MicrophoneBoldFilled",
  "MicrophoneBoldStroke",
  "MicrophoneMediumFilled",
  "MicrophoneMediumStroke",
  "MicrophoneMuteBoldFilled",
  "MicrophoneMuteBoldStroke",
  "MicrophoneMuteMediumFilled",
  "MicrophoneMuteMediumStroke",
  "MicrophoneMuteRegularFilled",
  "MicrophoneMuteRegularStroke",
  "MicrophoneOffBoldFilled",
  "MicrophoneOffBoldStroke",
  "MicrophoneOffMediumFilled",
  "MicrophoneOffMediumStroke",
  "MicrophoneOffRegularFilled",
  "MicrophoneOffRegularStroke",
  "MicrophoneRegularFilled",
  "MicrophoneRegularStroke",
  "MinusBoldStroke",
  "MinusInCircleBoldFilled",
  "MinusInCircleBoldStroke",
  "MinusInCircleMediumFilled",
  "MinusInCircleMediumStroke",
  "MinusInCircleRegularFilled",
  "MinusInCircleRegularStroke",
  "MinusMediumStroke",
  "MinusRegularStroke",
  "MobilePhoneBoldFilled",
  "MobilePhoneBoldStroke",
  "MobilePhoneMediumFilled",
  "MobilePhoneMediumStroke",
  "MobilePhoneRegularFilled",
  "MobilePhoneRegularStroke",
  "MoreHorizontalBoldStroke",
  "MoreHorizontalMediumStroke",
  "MoreHorizontalRegularStroke",
  "MoreVerticalBoldStroke",
  "MoreVerticalMediumStroke",
  "MoreVerticalRegularStroke",
  "MoveBoldStroke",
  "MoveMediumStroke",
  "MoveRegularStroke",
  "MoveToBoldFilled",
  "MoveToBoldStroke",
  "MoveToMediumFilled",
  "MoveToMediumStroke",
  "MoveToRegularFilled",
  "MoveToRegularStroke",
  "NoteBoldFilled",
  "NoteBoldStroke",
  "NoteEditBoldFilled",
  "NoteEditBoldStroke",
  "NoteEditMediumFilled",
  "NoteEditMediumStroke",
  "NoteEditRegularFilled",
  "NoteEditRegularStroke",
  "NoteMediumFilled",
  "NoteMediumStroke",
  "NoteRegularFilled",
  "NoteRegularStroke",
  "NotificationBoldFilled",
  "NotificationBoldStroke",
  "NotificationMediumFilled",
  "NotificationMediumStroke",
  "NotificationRegularFilled",
  "NotificationRegularStroke",
  "OnlineEventsBoldFilled",
  "OnlineEventsBoldStroke",
  "OnlineEventsMediumFilled",
  "OnlineEventsMediumStroke",
  "OnlineEventsRegularFilled",
  "OnlineEventsRegularStroke",
  "OpenInNewTabBoldStroke",
  "OpenInNewTabMediumStroke",
  "OpenInNewTabRegularStroke",
  "OrganizationBoldFilled",
  "OrganizationBoldStroke",
  "OrganizationMediumFilled",
  "OrganizationMediumStroke",
  "OrganizationRegularFilled",
  "OrganizationRegularStroke",
  "PauseBoldStroke",
  "PauseMediumStroke",
  "PauseRegularStroke",
  "PdfBoldFilled",
  "PdfBoldStroke",
  "PdfMediumFilled",
  "PdfMediumStroke",
  "PdfRegularFilled",
  "PdfRegularStroke",
  "PersonOnScreenBoldFilled",
  "PersonOnScreenBoldStroke",
  "PersonOnScreenMediumFilled",
  "PersonOnScreenMediumStroke",
  "PersonOnScreenRegularFilled",
  "PersonOnScreenRegularStroke",
  "PhoneBoldFilled",
  "PhoneBoldStroke",
  "PhoneMediumFilled",
  "PhoneMediumStroke",
  "PhoneRegularFilled",
  "PhoneRegularStroke",
  "PictureInPictureBoldFilled",
  "PictureInPictureBoldStroke",
  "PictureInPictureMediumFilled",
  "PictureInPictureMediumStroke",
  "PictureInPictureRegularFilled",
  "PictureInPictureRegularStroke",
  "PinDiagonalBoldFilled",
  "PinDiagonalBoldStroke",
  "PinDiagonalMediumFilled",
  "PinDiagonalMediumStroke",
  "PinDiagonalRegularFilled",
  "PinDiagonalRegularStroke",
  "PinVerticalBoldFilled",
  "PinVerticalBoldStroke",
  "PinVerticalMediumFilled",
  "PinVerticalMediumStroke",
  "PinVerticalRegularFilled",
  "PinVerticalRegularStroke",
  "PlanetBoldFilled",
  "PlanetBoldStroke",
  "PlanetMediumFilled",
  "PlanetMediumStroke",
  "PlanetRegularFilled",
  "PlanetRegularStroke",
  "PlayBoldFilled",
  "PlayBoldStroke",
  "PlayMediumFilled",
  "PlayMediumStroke",
  "PlayRegularFilled",
  "PlayRegularStroke",
  "PlusBoldStroke",
  "PlusInCircleBoldFilled",
  "PlusInCircleBoldStroke",
  "PlusInCircleMediumFilled",
  "PlusInCircleMediumStroke",
  "PlusInCircleRegularFilled",
  "PlusInCircleRegularStroke",
  "PlusMediumStroke",
  "PlusRegularStroke",
  "PreferencesBoldFilled",
  "PreferencesBoldStroke",
  "PreferencesMediumFilled",
  "PreferencesMediumStroke",
  "PreferencesRegularFilled",
  "PreferencesRegularStroke",
  "PrinterBoldFilled",
  "PrinterBoldStroke",
  "PrinterMediumFilled",
  "PrinterMediumStroke",
  "PrinterRegularFilled",
  "PrinterRegularStroke",
  "ProgramBoldFilled",
  "ProgramBoldStroke",
  "ProgramMediumFilled",
  "ProgramMediumStroke",
  "ProgramRegularFilled",
  "ProgramRegularStroke",
  "PropertiesBoldStroke",
  "QuestionBoldFilled",
  "QuestionBoldStroke",
  "QuestionMediumFilled",
  "QuestionMediumStroke",
  "QuestionPoolBoldFilled",
  "QuestionPoolBoldStroke",
  "QuestionPoolMediumFilled",
  "QuestionPoolMediumStroke",
  "QuestionPoolRegularFilled",
  "QuestionPoolRegularStroke",
  "QuestionRegularFilled",
  "QuestionRegularStroke",
  "QuizBoldFilled",
  "QuizBoldStroke",
  "QuizMediumFilled",
  "QuizMediumStroke",
  "QuizRegularFilled",
  "QuizRegularStroke",
  "RadiusBoldStroke",
  "RadiusMediumStroke",
  "RadiusRegularStroke",
  "RatioLockedBoldStroke",
  "RatioLockedMediumStroke",
  "RatioLockedRegularStroke",
  "RatioUnlockedBoldStroke",
  "RatioUnlockedMediumStroke",
  "RatioUnlockedRegularStroke",
  "ReaderModeBoldFilled",
  "ReaderModeBoldStroke",
  "ReaderModeMediumFilled",
  "ReaderModeMediumStroke",
  "ReaderModeRegularFilled",
  "ReaderModeRegularStroke",
  "RecordBoldStroke",
  "RecordMediumStroke",
  "RecordRegularStroke",
  "RedoBoldStroke",
  "RedoMediumStroke",
  "RedoRegularStroke",
  "RelationsBoldFilled",
  "RelationsBoldStroke",
  "RelationsMediumFilled",
  "RelationsMediumStroke",
  "RelationsRegularFilled",
  "RelationsRegularStroke",
  "RepeatBoldStroke",
  "RepeatMediumStroke",
  "RepeatRegularStroke",
  "ReplyBoldStroke",
  "ReplyMediumStroke",
  "ReplyRegularStroke",
  "ReturnBoldStroke",
  "ReturnMediumStroke",
  "ReturnRegularStroke",
  "RewindBackBoldStroke",
  "RewindBackMediumStroke",
  "RewindBackRegularStroke",
  "RewindForwardBoldStroke",
  "RewindForwardMediumStroke",
  "RewindForwardRegularStroke",
  "RichTextBoldStroke",
  "RichTextMediumStroke",
  "RightSidePanelBoldStroke",
  "RightSidePanelMediumStroke",
  "RightSidePanelRegularStroke",
  "RouteBoldFilled",
  "RouteBoldStroke",
  "RouteMediumFilled",
  "RouteMediumStroke",
  "RouteRegularFilled",
  "RouteRegularStroke",
  "ScheduledVideoBoldFilled",
  "ScheduledVideoBoldStroke",
  "ScheduledVideoMediumFilled",
  "ScheduledVideoMediumStroke",
  "ScheduledVideoRegularFilled",
  "ScheduledVideoRegularStroke",
  "ScormBoldFilled",
  "ScormBoldStroke",
  "ScormMediumFilled",
  "ScormMediumStroke",
  "ScormRegularFilled",
  "ScormRegularStroke",
  "SearchBoldStroke",
  "SearchEditBoldStroke",
  "SearchEditMediumStroke",
  "SearchEditRegularStroke",
  "SearchHistoryBoldStroke",
  "SearchHistoryMediumStroke",
  "SearchHistoryRegularStroke",
  "SearchMediumStroke",
  "SearchOffBoldStroke",
  "SearchOffMediumStroke",
  "SearchOffRegularStroke",
  "SearchRegularStroke",
  "SectionBoldStroke",
  "SectionMediumStroke",
  "SectionRegularStroke",
  "SendBoldFilled",
  "SendBoldStroke",
  "SendMediumFilled",
  "SendMediumStroke",
  "SendRegularFilled",
  "SendRegularStroke",
  "SettingsBoldFilled",
  "SettingsBoldStroke",
  "SettingsMediumFilled",
  "SettingsMediumStroke",
  "SettingsRegularFilled",
  "SettingsRegularStroke",
  "ShareAppleBoldFilled",
  "ShareAppleBoldStroke",
  "ShareAppleMediumFilled",
  "ShareAppleMediumStroke",
  "ShareAppleRegularFilled",
  "ShareAppleRegularStroke",
  "ShareBoldFilled",
  "ShareBoldStroke",
  "ShareMediumFilled",
  "ShareMediumStroke",
  "ShareNewBoldFilled",
  "ShareNewBoldStroke",
  "ShareRegularFilled",
  "ShareRegularStroke",
  "ShoppingBagBoldFilled",
  "ShoppingBagBoldStroke",
  "ShoppingBagMediumFilled",
  "ShoppingBagMediumStroke",
  "ShoppingBagRegularFilled",
  "ShoppingBagRegularStroke",
  "ShuffleBoldStroke",
  "ShuffleMediumStroke",
  "ShuffleRegularStroke",
  "SideViewBoldFilled",
  "SideViewBoldStroke",
  "SideViewMediumFilled",
  "SideViewMediumStroke",
  "SideViewRegularFilled",
  "SideViewRegularStroke",
  "SingleTimelineBoldFilled",
  "SingleTimelineBoldStroke",
  "SingleTimelineMediumFilled",
  "SingleTimelineMediumStroke",
  "SingleTimelineRegularFilled",
  "SingleTimelineRegularStroke",
  "SkipNextBoldFilled",
  "SkipNextBoldStroke",
  "SkipNextMediumFilled",
  "SkipNextMediumStroke",
  "SkipNextRegularFilled",
  "SkipNextRegularStroke",
  "SkipPreviousBoldFilled",
  "SkipPreviousBoldStroke",
  "SkipPreviousMediumFilled",
  "SkipPreviousMediumStroke",
  "SkipPreviousRegularFilled",
  "SkipPreviousRegularStroke",
  "SlideDownBoldFilled",
  "SlideLeftBoldFilled",
  "SlideRightBoldFilled",
  "SlideUpBoldFilled",
  "SmallCircleBoldFilled",
  "SmallCircleBoldStroke",
  "SmallCircleMediumFilled",
  "SmallCircleMediumStroke",
  "SmallCircleRegularFilled",
  "SmallCircleRegularStroke",
  "SortHighToLowBoldStroke",
  "SortHighToLowMediumStroke",
  "SortHighToLowRegularStroke",
  "SortLowToHighBoldStroke",
  "SortLowToHighMediumStroke",
  "SortLowToHighRegularStroke",
  "SoundBoldFilled",
  "SoundBoldStroke",
  "SoundLowBoldFilled",
  "SoundLowBoldStroke",
  "SoundLowMediumFilled",
  "SoundLowMediumStroke",
  "SoundLowRegularFilled",
  "SoundLowRegularStroke",
  "SoundMediumBoldFilled",
  "SoundMediumBoldStroke",
  "SoundMediumFilled",
  "SoundMediumMediumFilled",
  "SoundMediumMediumStroke",
  "SoundMediumRegularFilled",
  "SoundMediumRegularStroke",
  "SoundMediumStroke",
  "SoundOffBoldFilled",
  "SoundOffBoldStroke",
  "SoundOffMediumFilled",
  "SoundOffMediumStroke",
  "SoundOffRegularFilled",
  "SoundOffRegularStroke",
  "SoundRegularFilled",
  "SoundRegularStroke",
  "SpeechBoldFilled",
  "SpeechBoldStroke",
  "SpeechMediumFilled",
  "SpeechMediumStroke",
  "SpeechRegularFilled",
  "SpeechRegularStroke",
  "SplitBoldStroke",
  "SplitMediumStroke",
  "SplitRegularStroke",
  "SportsCupBoldFilled",
  "SportsCupBoldStroke",
  "SportsCupMediumFilled",
  "SportsCupMediumStroke",
  "SportsCupRegularFilled",
  "SportsCupRegularStroke",
  "StarBoldFilled",
  "StarBoldStroke",
  "StarMediumFilled",
  "StarMediumStroke",
  "StarRegularFilled",
  "StarRegularStroke",
  "StarsBoldFilled",
  "StarsMediumFilled",
  "StarsRegularFilled",
  "StopBoldFilled",
  "StopBoldStroke",
  "StopCircleBoldFilled",
  "StopCircleBoldStroke",
  "StopCircleMediumFilled",
  "StopCircleMediumStroke",
  "StopCircleRegularFilled",
  "StopCircleRegularStroke",
  "StopMediumFilled",
  "StopMediumStroke",
  "StopRegularFilled",
  "StopRegularStroke",
  "StrikedTextRegularFilled",
  "SurveyBoldStroke",
  "SurveyMediumStroke",
  "SurveyRegularStroke",
  "TextAlignCenterBoldStroke",
  "TextAlignCenterMediumStroke",
  "TextAlignCenterRegularStroke",
  "TextAlignLeftBoldStroke",
  "TextAlignLeftMediumStroke",
  "TextAlignLeftRegularStroke",
  "TextAlignRightBoldStroke",
  "TextAlignRightMediumStroke",
  "TextAlignRightRegularStroke",
  "ThumbDownBoldFilled",
  "ThumbDownBoldStroke",
  "ThumbDownMediumFilled",
  "ThumbDownMediumStroke",
  "ThumbDownRegularFilled",
  "ThumbDownRegularStroke",
  "ThumbUpBoldFilled",
  "ThumbUpBoldStroke",
  "ThumbUpMediumFilled",
  "ThumbUpMediumStroke",
  "ThumbUpRegularFilled",
  "ThumbUpRegularStroke",
  "TicketBoldFilled",
  "TicketBoldStroke",
  "TicketMediumFilled",
  "TicketMediumStroke",
  "TicketRegularFilled",
  "TicketRegularStroke",
  "TidyUpBoldFilled",
  "TimeBoldFilled",
  "TimeBoldStroke",
  "TimeMediumFilled",
  "TimeMediumStroke",
  "TimeRegularFilled",
  "TimeRegularStroke",
  "TimerBoldStroke",
  "TimerMediumStroke",
  "TimerRegularStroke",
  "TopSidePanelBoldStroke",
  "TopSidePanelMediumStroke",
  "TopSidePanelRegularStroke",
  "TransferBoldStroke",
  "TransferMediumStroke",
  "TransferRegularStroke",
  "TransformBoldStroke",
  "TransformMediumStroke",
  "TransformRegularStroke",
  "TranslateBoldStroke",
  "TranslateMediumStroke",
  "TranslateRegularStroke",
  "TrendingDownBoldStroke",
  "TrendingDownMediumStroke",
  "TrendingDownRegularStroke",
  "TrendingFlatBoldStroke",
  "TrendingFlatMediumStroke",
  "TrendingFlatRegularStroke",
  "TrendingUpBoldStroke",
  "TrendingUpMediumStroke",
  "TrendingUpRegularStroke",
  "TriangleBoldFilled",
  "TriangleBoldStroke",
  "TriangleMediumFilled",
  "TriangleMediumStroke",
  "TriangleRegularFilled",
  "TriangleRegularStroke",
  "UnderlineTextRegularFilled",
  "UndoBoldStroke",
  "UndoMediumStroke",
  "UndoRegularStroke",
  "UpdateBoldStroke",
  "UpdateMediumStroke",
  "UpdateRegularStroke",
  "UploadBoldStroke",
  "UploadMediumStroke",
  "UploadRegularStroke",
  "UserBoldFilled",
  "UserBoldStroke",
  "UserMediumFilled",
  "UserMediumStroke",
  "UserRegularFilled",
  "UserRegularStroke",
  "VerticalPageBoldFilled",
  "VerticalPageBoldStroke",
  "VerticalPageMediumFilled",
  "VerticalPageMediumStroke",
  "VerticalPageRegularFilled",
  "VerticalPageRegularStroke",
  "VideoBoldFilled",
  "VideoBoldStroke",
  "VideoMediumFilled",
  "VideoMediumStroke",
  "VideoRegularFilled",
  "VideoRegularStroke",
  "VoteBoldFilled",
  "VoteBoldStroke",
  "VoteMediumFilled",
  "VoteMediumStroke",
  "VoteRegularFilled",
  "VoteRegularStroke",
  "WalkBoldFilled",
  "WalkBoldStroke",
  "WalkMediumFilled",
  "WalkMediumStroke",
  "WalkRegularFilled",
  "WalkRegularStroke",
  "WarningBoldFilled",
  "WarningBoldStroke",
  "WarningMediumFilled",
  "WarningMediumStroke",
  "WarningRegularFilled",
  "WarningRegularStroke",
  "WhiteboardBoldFilled",
  "WhiteboardBoldStroke",
  "WhiteboardMediumFilled",
  "WhiteboardMediumStroke",
  "WhiteboardNewBoldFilled",
  "WhiteboardNewBoldStroke",
  "WhiteboardRegularFilled",
  "WhiteboardRegularStroke",
  "WifiBoldStroke",
  "WifiMediumStroke",
  "WifiRegularStroke",
  "WindowBoldFilled",
  "WindowBoldStroke",
  "WindowMediumFilled",
  "WindowMediumStroke",
  "WindowRegularFilled",
  "WindowRegularStroke",
  "WorkBagBoldFilled",
  "WorkBagBoldStroke",
  "WorkBagMediumFilled",
  "WorkBagMediumStroke",
  "WorkBagRegularFilled",
  "WorkBagRegularStroke",
  "XlsBoldFilled",
  "XlsBoldStroke",
  "XlsMediumFilled",
  "XlsMediumStroke",
  "XlsRegularFilled",
  "XlsRegularStroke",
  "XlsxBoldFilled",
  "XlsxBoldStroke",
  "XlsxMediumFilled",
  "XlsxMediumStroke",
  "XlsxRegularFilled",
  "XlsxRegularStroke",
  "AcronisHeaderLogo",
  "AlemiraLogo",
  "ConstructorLogo",
  "Germany",
  "LogoAcronis",
  "LogoCub",
  "LogoDatarockstars",
  "LogoJub",
  "LogoOxford",
  "Logo",
  "Russia",
  "UnitedKingdom",
  "User"
];
var X = { exports: {} }, I = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ve;
function kl() {
  if (ve) return I;
  ve = 1;
  var m = be, c = Symbol.for("react.element"), f = Symbol.for("react.fragment"), p = Object.prototype.hasOwnProperty, w = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, O = { key: !0, ref: !0, __self: !0, __source: !0 };
  function E(C, S, A) {
    var s, R = {}, h = null, L = null;
    A !== void 0 && (h = "" + A), S.key !== void 0 && (h = "" + S.key), S.ref !== void 0 && (L = S.ref);
    for (s in S) p.call(S, s) && !O.hasOwnProperty(s) && (R[s] = S[s]);
    if (C && C.defaultProps) for (s in S = C.defaultProps, S) R[s] === void 0 && (R[s] = S[s]);
    return { $$typeof: c, type: C, key: h, ref: L, props: R, _owner: w.current };
  }
  return I.Fragment = f, I.jsx = E, I.jsxs = E, I;
}
var x = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var we;
function gl() {
  return we || (we = 1, process.env.NODE_ENV !== "production" && function() {
    var m = be, c = Symbol.for("react.element"), f = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), O = Symbol.for("react.profiler"), E = Symbol.for("react.provider"), C = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), A = Symbol.for("react.suspense"), s = Symbol.for("react.suspense_list"), R = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), L = Symbol.for("react.offscreen"), Z = Symbol.iterator, Te = "@@iterator";
    function Pe(e) {
      if (e === null || typeof e != "object")
        return null;
      var l = Z && e[Z] || e[Te];
      return typeof l == "function" ? l : null;
    }
    var b = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function k(e) {
      {
        for (var l = arguments.length, r = new Array(l > 1 ? l - 1 : 0), o = 1; o < l; o++)
          r[o - 1] = arguments[o];
        Ee("error", e, r);
      }
    }
    function Ee(e, l, r) {
      {
        var o = b.ReactDebugCurrentFrame, d = o.getStackAddendum();
        d !== "" && (l += "%s", r = r.concat([d]));
        var a = r.map(function(t) {
          return String(t);
        });
        a.unshift("Warning: " + l), Function.prototype.apply.call(console[e], console, a);
      }
    }
    var ye = !1, De = !1, Ie = !1, xe = !1, Oe = !1, ee;
    ee = Symbol.for("react.module.reference");
    function Le(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === p || e === O || Oe || e === w || e === A || e === s || xe || e === L || ye || De || Ie || typeof e == "object" && e !== null && (e.$$typeof === h || e.$$typeof === R || e.$$typeof === E || e.$$typeof === C || e.$$typeof === S || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ee || e.getModuleId !== void 0));
    }
    function _e(e, l, r) {
      var o = e.displayName;
      if (o)
        return o;
      var d = l.displayName || l.name || "";
      return d !== "" ? r + "(" + d + ")" : r;
    }
    function le(e) {
      return e.displayName || "Context";
    }
    function B(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && k("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case p:
          return "Fragment";
        case f:
          return "Portal";
        case O:
          return "Profiler";
        case w:
          return "StrictMode";
        case A:
          return "Suspense";
        case s:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case C:
            var l = e;
            return le(l) + ".Consumer";
          case E:
            var r = e;
            return le(r._context) + ".Provider";
          case S:
            return _e(e, e.render, "ForwardRef");
          case R:
            var o = e.displayName || null;
            return o !== null ? o : B(e.type) || "Memo";
          case h: {
            var d = e, a = d._payload, t = d._init;
            try {
              return B(t(a));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v = Object.assign, y = 0, re, oe, ie, te, de, ae, ue;
    function ne() {
    }
    ne.__reactDisabledLog = !0;
    function Ue() {
      {
        if (y === 0) {
          re = console.log, oe = console.info, ie = console.warn, te = console.error, de = console.group, ae = console.groupCollapsed, ue = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        y++;
      }
    }
    function Ve() {
      {
        if (y--, y === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: v({}, e, {
              value: re
            }),
            info: v({}, e, {
              value: oe
            }),
            warn: v({}, e, {
              value: ie
            }),
            error: v({}, e, {
              value: te
            }),
            group: v({}, e, {
              value: de
            }),
            groupCollapsed: v({}, e, {
              value: ae
            }),
            groupEnd: v({}, e, {
              value: ue
            })
          });
        }
        y < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var j = b.ReactCurrentDispatcher, N;
    function _(e, l, r) {
      {
        if (N === void 0)
          try {
            throw Error();
          } catch (d) {
            var o = d.stack.trim().match(/\n( *(at )?)/);
            N = o && o[1] || "";
          }
        return `
` + N + e;
      }
    }
    var G = !1, U;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      U = new We();
    }
    function Se(e, l) {
      if (!e || G)
        return "";
      {
        var r = U.get(e);
        if (r !== void 0)
          return r;
      }
      var o;
      G = !0;
      var d = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var a;
      a = j.current, j.current = null, Ue();
      try {
        if (l) {
          var t = function() {
            throw Error();
          };
          if (Object.defineProperty(t.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(t, []);
            } catch (M) {
              o = M;
            }
            Reflect.construct(e, [], t);
          } else {
            try {
              t.call();
            } catch (M) {
              o = M;
            }
            e.call(t.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (M) {
            o = M;
          }
          e();
        }
      } catch (M) {
        if (M && o && typeof M.stack == "string") {
          for (var i = M.stack.split(`
`), g = o.stack.split(`
`), u = i.length - 1, n = g.length - 1; u >= 1 && n >= 0 && i[u] !== g[n]; )
            n--;
          for (; u >= 1 && n >= 0; u--, n--)
            if (i[u] !== g[n]) {
              if (u !== 1 || n !== 1)
                do
                  if (u--, n--, n < 0 || i[u] !== g[n]) {
                    var F = `
` + i[u].replace(" at new ", " at ");
                    return e.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", e.displayName)), typeof e == "function" && U.set(e, F), F;
                  }
                while (u >= 1 && n >= 0);
              break;
            }
        }
      } finally {
        G = !1, j.current = a, Ve(), Error.prepareStackTrace = d;
      }
      var P = e ? e.displayName || e.name : "", he = P ? _(P) : "";
      return typeof e == "function" && U.set(e, he), he;
    }
    function He(e, l, r) {
      return Se(e, !1);
    }
    function je(e) {
      var l = e.prototype;
      return !!(l && l.isReactComponent);
    }
    function V(e, l, r) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Se(e, je(e));
      if (typeof e == "string")
        return _(e);
      switch (e) {
        case A:
          return _("Suspense");
        case s:
          return _("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case S:
            return He(e.render);
          case R:
            return V(e.type, l, r);
          case h: {
            var o = e, d = o._payload, a = o._init;
            try {
              return V(a(d), l, r);
            } catch {
            }
          }
        }
      return "";
    }
    var W = Object.prototype.hasOwnProperty, ke = {}, ge = b.ReactDebugCurrentFrame;
    function H(e) {
      if (e) {
        var l = e._owner, r = V(e.type, e._source, l ? l.type : null);
        ge.setExtraStackFrame(r);
      } else
        ge.setExtraStackFrame(null);
    }
    function Ne(e, l, r, o, d) {
      {
        var a = Function.call.bind(W);
        for (var t in e)
          if (a(e, t)) {
            var i = void 0;
            try {
              if (typeof e[t] != "function") {
                var g = Error((o || "React class") + ": " + r + " type `" + t + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[t] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw g.name = "Invariant Violation", g;
              }
              i = e[t](l, t, o, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (u) {
              i = u;
            }
            i && !(i instanceof Error) && (H(d), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", o || "React class", r, t, typeof i), H(null)), i instanceof Error && !(i.message in ke) && (ke[i.message] = !0, H(d), k("Failed %s type: %s", r, i.message), H(null));
          }
      }
    }
    var Ge = Array.isArray;
    function $(e) {
      return Ge(e);
    }
    function $e(e) {
      {
        var l = typeof Symbol == "function" && Symbol.toStringTag, r = l && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r;
      }
    }
    function ze(e) {
      try {
        return me(e), !1;
      } catch {
        return !0;
      }
    }
    function me(e) {
      return "" + e;
    }
    function ce(e) {
      if (ze(e))
        return k("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $e(e)), me(e);
    }
    var D = b.ReactCurrentOwner, Qe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, se, Fe, z;
    z = {};
    function Ye(e) {
      if (W.call(e, "ref")) {
        var l = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function qe(e) {
      if (W.call(e, "key")) {
        var l = Object.getOwnPropertyDescriptor(e, "key").get;
        if (l && l.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Xe(e, l) {
      if (typeof e.ref == "string" && D.current && l && D.current.stateNode !== l) {
        var r = B(D.current.type);
        z[r] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', B(D.current.type), e.ref), z[r] = !0);
      }
    }
    function Je(e, l) {
      {
        var r = function() {
          se || (se = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: r,
          configurable: !0
        });
      }
    }
    function Ke(e, l) {
      {
        var r = function() {
          Fe || (Fe = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", l));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: r,
          configurable: !0
        });
      }
    }
    var Ze = function(e, l, r, o, d, a, t) {
      var i = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: c,
        // Built-in properties that belong on the element
        type: e,
        key: l,
        ref: r,
        props: t,
        // Record the component responsible for creating this element.
        _owner: a
      };
      return i._store = {}, Object.defineProperty(i._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(i, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: o
      }), Object.defineProperty(i, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: d
      }), Object.freeze && (Object.freeze(i.props), Object.freeze(i)), i;
    };
    function el(e, l, r, o, d) {
      {
        var a, t = {}, i = null, g = null;
        r !== void 0 && (ce(r), i = "" + r), qe(l) && (ce(l.key), i = "" + l.key), Ye(l) && (g = l.ref, Xe(l, d));
        for (a in l)
          W.call(l, a) && !Qe.hasOwnProperty(a) && (t[a] = l[a]);
        if (e && e.defaultProps) {
          var u = e.defaultProps;
          for (a in u)
            t[a] === void 0 && (t[a] = u[a]);
        }
        if (i || g) {
          var n = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          i && Je(t, n), g && Ke(t, n);
        }
        return Ze(e, i, g, d, o, D.current, t);
      }
    }
    var Q = b.ReactCurrentOwner, Re = b.ReactDebugCurrentFrame;
    function T(e) {
      if (e) {
        var l = e._owner, r = V(e.type, e._source, l ? l.type : null);
        Re.setExtraStackFrame(r);
      } else
        Re.setExtraStackFrame(null);
    }
    var Y;
    Y = !1;
    function q(e) {
      return typeof e == "object" && e !== null && e.$$typeof === c;
    }
    function Be() {
      {
        if (Q.current) {
          var e = B(Q.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function ll(e) {
      return "";
    }
    var Me = {};
    function rl(e) {
      {
        var l = Be();
        if (!l) {
          var r = typeof e == "string" ? e : e.displayName || e.name;
          r && (l = `

Check the top-level render call using <` + r + ">.");
        }
        return l;
      }
    }
    function fe(e, l) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var r = rl(l);
        if (Me[r])
          return;
        Me[r] = !0;
        var o = "";
        e && e._owner && e._owner !== Q.current && (o = " It was passed a child from " + B(e._owner.type) + "."), T(e), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, o), T(null);
      }
    }
    function pe(e, l) {
      {
        if (typeof e != "object")
          return;
        if ($(e))
          for (var r = 0; r < e.length; r++) {
            var o = e[r];
            q(o) && fe(o, l);
          }
        else if (q(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var d = Pe(e);
          if (typeof d == "function" && d !== e.entries)
            for (var a = d.call(e), t; !(t = a.next()).done; )
              q(t.value) && fe(t.value, l);
        }
      }
    }
    function ol(e) {
      {
        var l = e.type;
        if (l == null || typeof l == "string")
          return;
        var r;
        if (typeof l == "function")
          r = l.propTypes;
        else if (typeof l == "object" && (l.$$typeof === S || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        l.$$typeof === R))
          r = l.propTypes;
        else
          return;
        if (r) {
          var o = B(l);
          Ne(r, e.props, "prop", o, e);
        } else if (l.PropTypes !== void 0 && !Y) {
          Y = !0;
          var d = B(l);
          k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", d || "Unknown");
        }
        typeof l.getDefaultProps == "function" && !l.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function il(e) {
      {
        for (var l = Object.keys(e.props), r = 0; r < l.length; r++) {
          var o = l[r];
          if (o !== "children" && o !== "key") {
            T(e), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", o), T(null);
            break;
          }
        }
        e.ref !== null && (T(e), k("Invalid attribute `ref` supplied to `React.Fragment`."), T(null));
      }
    }
    function Ce(e, l, r, o, d, a) {
      {
        var t = Le(e);
        if (!t) {
          var i = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (i += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var g = ll();
          g ? i += g : i += Be();
          var u;
          e === null ? u = "null" : $(e) ? u = "array" : e !== void 0 && e.$$typeof === c ? (u = "<" + (B(e.type) || "Unknown") + " />", i = " Did you accidentally export a JSX literal instead of a component?") : u = typeof e, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", u, i);
        }
        var n = el(e, l, r, d, a);
        if (n == null)
          return n;
        if (t) {
          var F = l.children;
          if (F !== void 0)
            if (o)
              if ($(F)) {
                for (var P = 0; P < F.length; P++)
                  pe(F[P], e);
                Object.freeze && Object.freeze(F);
              } else
                k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              pe(F, e);
        }
        return e === p ? il(n) : ol(n), n;
      }
    }
    function tl(e, l, r) {
      return Ce(e, l, r, !0);
    }
    function dl(e, l, r) {
      return Ce(e, l, r, !1);
    }
    var al = dl, ul = tl;
    x.Fragment = p, x.jsx = al, x.jsxs = ul;
  }()), x;
}
process.env.NODE_ENV === "production" ? X.exports = kl() : X.exports = gl();
var J = X.exports;
const K = nl(null);
K.displayName = "SvgConfigurationContext";
const ml = () => {
  const m = Sl(K);
  if (m === null)
    throw new Error("useSvgConfiguration must be used within a SvgProvider");
  return m;
}, Rl = ({ children: m, filename: c }) => /* @__PURE__ */ J.jsx(K.Provider, { value: { filename: c }, children: m }), Ae = 24, Bl = ({ name: m, ...c }) => {
  const { filename: f } = ml(), {
    width: p,
    height: w
  } = cl(c);
  return /* @__PURE__ */ J.jsx("svg", { ...c, width: p, height: w, children: /* @__PURE__ */ J.jsx("use", { href: `${f}#${m}` }) });
};
function cl({ size: m, width: c, height: f }) {
  return m !== void 0 ? { width: m, height: m } : c !== void 0 || f !== void 0 ? { width: c, height: f } : { width: Ae, height: Ae };
}
export {
  Bl as SvgComponent,
  Rl as SvgProvider,
  Fl as availableSvgs,
  ml as useSvgConfiguration
};
